import type { LibraryItem } from '@/api/types'
import { AddToPlaylistSheet } from '@/components/selection/AddToPlaylistSheet'

export interface AddToPlaylistDialogProps { item: LibraryItem; onClose: () => void }

export function AddToPlaylistDialog({ item, onClose }: AddToPlaylistDialogProps) {
  return <AddToPlaylistSheet open trackIds={[item.track.id]} onOpenChange={(open) => { if (!open) onClose() }} />
}
